import { ReturnStruct } from "src/app/shared/structs/return.struct";
import { SupportContactModel } from "../../models/admin-user/support-contact.model";

export class ListSupportContactRequest extends ReturnStruct{
    public supportContact: SupportContactModel[] = [];
}